export default "__VITE_ASSET__BqmGjWGv__"